import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const linearGradientProps = {
  x1: 1,
  x2: 0.6,
  y1: 1,
  y2: 0,
};
const gradients = [
  {
    id: 'svg-common-gradient',
    rotation: 0,
    colors: [
      { color: '#D1DCDF', offset: 0 },
      { color: 'white', offset: 1 },
    ],
  },
  {
    id: 'svg-limited-gradient',
    rotation: 0,
    colors: [
      { color: '#E67C00', offset: 0 },
      { color: '#F7B100', offset: 1 },
    ],
  },
  {
    id: 'svg-mix-gradient',
    rotation: 0,
    colors: [
      { color: '#391885', offset: 0 },
      { color: '#c43ba9', offset: 1 },
    ],
  },
  {
    id: 'svg-rare-gradient',
    rotation: 0,
    colors: [
      { color: '#800000', offset: 0 },
      { color: '#EA000C', offset: 1 },
    ],
  },
  {
    id: 'svg-super_rare-gradient',
    rotation: 0,
    colors: [
      { color: '#179EFF', offset: 0 },
      { color: '#0A42D0', offset: 1 },
    ],
  },
  {
    id: 'svg-unique-gradient',
    rotation: 0,
    colors: [
      { color: '#29073C', offset: 0 },
      { color: '#AC11FF', offset: 1 },
    ],
  },
  {
    id: 'svg-rookie-gradient',
    rotation: 0,
    colors: [{ color: '#101010', offset: 0 }],
  },
  {
    id: 'svg-academy-gradient',
    rotation: 0,
    colors: [
      { color: '#0840d1', offset: 0 },
      { color: '#00a3ff', offset: 1 },
    ],
  },
  {
    id: 'svg-rewards-1st-gradient',
    rotation: 0,
    colors: [
      { color: '#FFC931', offset: 0 },
      { color: '#FC7D22', offset: 1 },
    ],
  },
  {
    id: 'svg-rewards-2nd-gradient',
    rotation: 0,
    colors: [
      { color: '#FFFFFF', offset: 0 },
      { color: '#C0C0C0', offset: 1 },
    ],
  },
  {
    id: 'svg-rewards-3rd-gradient',
    rotation: 0,
    colors: [
      { color: '#EBA278', offset: 0 },
      { color: '#DCA883', offset: 1 },
    ],
  },
  {
    id: 'svg-rivals-rep-boost-gradient',
    rotation: 0,
    colors: [
      { color: 'var(--c-rivals-reputation)', offset: 0 },
      { color: 'var(--c-rivals-arena)', offset: 0.7 },
    ],
  },
  {
    id: 'svg-special-reward-gradient',
    rotation: 100,
    colors: [
      { color: 'var(--c-reward-900)', offset: 0 },
      { color: 'var(--c-reward-200)', offset: 1 },
    ],
  },
];

export const SvgProvider = ({ children }: Props) => {
  return (
    <>
      <svg
        aria-hidden="true"
        style={{ position: 'absolute', display: 'block', height: 0, width: 0 }}
      >
        {gradients.map(({ id, colors, rotation }) => {
          return (
            <linearGradient
              key={id}
              id={id}
              gradientTransform={`rotate(${rotation})`}
              {...linearGradientProps}
            >
              {colors.map(({ color, offset }) => (
                <stop key={color} offset={offset} stopColor={color} />
              ))}
            </linearGradient>
          );
        })}
      </svg>
      {children}
    </>
  );
};
